import Banner from './Banner';

interface AssemblyGuideBannerProps {
  item: CategoryData;
}

export default async function AssemblyGuideBanner({
  item,
}: AssemblyGuideBannerProps) {
  return (
    <Banner item={item} difficulty={item.difficulty} chapters={item.chapters} />
  );
}
